import axios from './axios_config';

export const getProject = async (projectId) => {
    let result = await axios.get(`/api/v1/project/${projectId}/`);
    return result;
};

export const getProjectTable = async (projectId) => {
    let result = await axios.get(`/api/v1/project/${projectId}/get-dataset/`);
    return result;
};

export const getProjectDataToPagination = async (projectId, currentPage) => {
    let result = await axios.get(
        `/api/v1/project/${projectId}/get-dataset/?page=${currentPage}`
    );
    return result;
};

export const updateOrCreateAnalysis = async (data, analysisId) => {
    let result = '';
    if (analysisId) {
        result = await axios.patch(`/api/v1/analysis/${analysisId}/`, data);
    } else {
        result = await axios.post(`/api/v1/analysis/`, data);
    }
    return result;
};

export const deleteAnalysis = async (analysisId) => {
    let result = await axios.delete(`/api/v1/analysis/${analysisId}/`);
    return result;
};

export const downloadProjectFile = async (projectId) => {
    let result = await axios
        .get(`/api/v1/project/${projectId}/export-dataset/`, {
            responseType: 'blob'
        })
        .then((response) => {
            const href = URL.createObjectURL(response.data);

            const link = document.createElement('a');
            link.href = href;

            if (response.headers.hasOwnProperty('content-disposition')) {
                let fileName = response.headers['content-disposition'];
                fileName = fileName.split('filename="')[1];

                fileName = fileName.substr(0, fileName.length - 1);
                console.log(
                    'Content-Disposition',
                    response.headers['content-disposition']
                );

                link.setAttribute('download', fileName); //or any other extension
            }

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        });
};

export const getAnalysisResults = async (analysisId) => {
    let result = await axios.get(
        `/api/v1/analysis/${analysisId}/perform-analysis/`
    );

    // console.log(`resgetAnalysisResults`, result);
    return result;
};

export const getStatisticsResults = async () => {
    let result = await axios.get(`/api/v1/statistics/`);
    return result;
};

export const updateOrCreateColumn = async (data, columnId) => {
    let result = '';
    if (columnId) {
        result = await axios.patch(`/api/v1/column/${columnId}/`, data);
        // console.log(`UPDATE`);
    } else {
        result = await axios.post(`/api/v1/column/`, data);
        // console.log(`CREATE`);
    }
    return result;
};

export const duplicateProject = async (idProject, name) => {
    let result = await axios.post(`/api/v1/project/${idProject}/duplicate/`, {
        name: name
    });
    return result;
};

export const changeProjectName = async (idProject, name) => {
    let result = await axios.patch(`/api/v1/project/${idProject}/`, {
        name: name
    });
    return result;
};

export const createManualData = async (data) => {
    let result = await axios.post(`/api/v1/file/manually-insert-data/`, data);
    return result;
};

export const uniqueValuesForColumn = async (idProject, columnID) => {
    let result = await axios.get(`/api/v1/project/${idProject}/unique-values-for-column/?column_index=${columnID}`);
    return result; //result list form column
};
